import { render } from "./SecondaryLink.vue?vue&type=template&id=cf24dde0"
import script from "./SecondaryLink.vue?vue&type=script&lang=js"
export * from "./SecondaryLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__